import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExcelConverterOptions  {
    _originalTypeClassName = "zERP.BO.ExcelConverterOptions";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExcelConverterOptions.translate = translateService;
}
this.CurrencyDecimalAccuracy = null;
this.DaysAccuracy = null;
this.HoursAccuracy = null;
this.RateAccuracy = null;
this.ExcelConverterOptionsKey = null;
this._key = this.ExcelConverterOptionsKey = 0; 
}

static translate: TranslateService;
_key: any;
CurrencyDecimalAccuracy:any;
DaysAccuracy:any;
HoursAccuracy:any;
RateAccuracy:any;
private _ExcelConverterOptionsKey:any;
get ExcelConverterOptionsKey(): any {
    return this._ExcelConverterOptionsKey;
  }
set ExcelConverterOptionsKey(value: any) {
    this._ExcelConverterOptionsKey = value;
    this._key = value;
  }

static CreateDefault(): any{let options = new Domain.ExcelConverterOptions();
options.CurrencyDecimalAccuracy = 2;
options.DaysAccuracy = 3;
options.HoursAccuracy = 2;
options.RateAccuracy = 6;
return options;
}
static CreateFromEntity(entity: any): any{let options = Domain.ExcelConverterOptions.CreateDefault();
if (entity != null) {options.CurrencyDecimalAccuracy = Domain.BusinessEntity.GetCurrencyAccuracy(entity);}
return options;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ExcelConverterOptionsKey == null || $this.ExcelConverterOptionsKey == 0;
            }


}